import React from 'react'

// query
import { useQuery } from '@apollo/client'
import { GET_CREW_MEMBER_BY_ID_WITH_NAME_AND_IS_FOREMAN } from '../../../../../graphql/crewMember/crewMember.queries'

// components
import Heading from '../../../../../components/text/Heading/Heading.component'

// icons
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome'
import { faHelmetSafety } from '@fortawesome/free-solid-svg-icons'

// styles
import './CrewDetailNameAndIsForeman.styles.css'

export default function CrewDetailNameAndIsForeman({ id }) {

    let crewMember = {}

    const { loading, error, data } = useQuery(GET_CREW_MEMBER_BY_ID_WITH_NAME_AND_IS_FOREMAN, {
        variables: { id }
    })

    if(data && data.crewMember) {
        crewMember = {...data.crewMember}
    }

    return (<div className='crew-detail-name-and-is-foreman'>
        <Heading text={`${crewMember.firstName} ${crewMember.lastName}`}/>
        <div className='crew-detail-name-and-is-foreman-icon'>
            {crewMember.isForeman ? <FontAwesomeIcon icon={faHelmetSafety} size='lg' color='#27AF0F' /> : null }
        </div>
        
    </div>)
}